import 'react';

/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === 'function') ref(value);else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */
function $6ed0406888f73fc4$export$43e446d32b3d21af() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return node => refs.forEach(ref => $6ed0406888f73fc4$var$setRef(ref, node));
}
export { $6ed0406888f73fc4$export$43e446d32b3d21af as composeRefs };
//# sourceMappingURL=index.js.map
